<script setup>
import { defineProps, defineEmits } from "vue";
import Icon from "@/components/Icon.vue";

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: "Title page"
    }
});

const emits = defineEmits(["callApi", "callBack"]);

const close = () => {
    emits("callBack", false);
};


</script>
<template>
    <Transition name="slide-up">
        <div v-if="show" class="fixed top-0 left-0 z-50 w-full h-full bg-white">
            <div class="w-full h-full overflow-auto">
                <div class="w-full fixed z-10 h-14 flex items-center bg-main px-6">
                    <div @click="close()" class="w-10 flex justify-start cursor-pointer">
                        <Icon name="close" class="w-5 h-5 fill-white"></Icon>
                    </div>
                    <div class="flex-1 text-center font-bold text-lg text-white">
                        {{ title }}
                    </div>
                    <div class="w-10 flex items-center justify-end">
                        <slot name="headerRight"></slot> 
                    </div>
                </div>
                <div class="w-full h-full pt-14">
                    <slot></slot>
                </div>
            </div>
        </div>
    </Transition>
</template>